import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-association-registration-athleteone',
  templateUrl: './association-registration-athleteone.component.html',
  styleUrls: ['./association-registration-athleteone.component.css']
})
export class AssociationRegistrationAthleteoneComponent implements OnInit {
  constructor(
    private _router: Router,
    private _loader: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this._loader.hide();
  }

  onClickLogInHere() {
    window.open('https://app.athleteone.com/auth/login', '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/association-registration-athleteone/association-registration-athleteone.component.ts